import Enum from "./Enum";

class EnumList {
  constructor() {
    this.List = new Map();
  }

  add(key, value) {
    let newEnum = new Enum(key, value);
    this.List.set(newEnum.Key, newEnum);
    return newEnum;
  }

  findByKey(key) {
    return this.List.get(key);
  }
}

export default EnumList;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/EnumList.js